import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Link } from "react-router-dom";
import classes from "./Profile.module.css";

const PreviousOrders = (props) => {
  const [orders, setOrders] = useState([
    {
      id: 1,
      title: "Sandwich 1",
      price: 120,
      date: "12-10-2021",
      image:
        "https://image.freepik.com/free-photo/kebab-platter-with-lamb-chicken-lula-tikka-kebabs-grilled-vegetables-with-red-onion-salad_141793-2251.jpg",
    },
    {
      id: 2,
      title: "Sandwich 1",
      price: 120,
      date: "12-10-2021",
      image:
        "https://image.freepik.com/free-photo/kebab-platter-with-lamb-chicken-lula-tikka-kebabs-grilled-vegetables-with-red-onion-salad_141793-2251.jpg",
    },
    {
      id: 3,
      title: "Sandwich 1",
      price: 120,
      date: "12-10-2021",
      image:
        "https://image.freepik.com/free-photo/kebab-platter-with-lamb-chicken-lula-tikka-kebabs-grilled-vegetables-with-red-onion-salad_141793-2251.jpg",
    },
  ]);
  return (
    <div className={classes.previousOrders}>
      {orders.map((row, index) => {
        return (
          <div className={classes.pOrderRow}>
            <img
              src={row.image}
              className={`img-fluid ${classes.pOrderView}`}
            />
            <div className={classes.pOrderBody}>
              <div className={classes.pOrderTitle}>{row.title}</div>
              <div className={classes.pOrderPriceDate}>
                <div className={classes.pOrderPrice}>{row.price} EGP</div>
                <span className={classes.pOrderCircle}></span>
                <div className={classes.pOrderDate}>{row.date}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { PreviousOrders };
